/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */
/**
 * Contains the selectors that select state from the 'ACESFI' store object.
 * @namespace ACESFISelectors
 */
export default class selectors {
  /**
   * @private
   */
  static moduleIdentifier = 'UAACESFI';

  /**
   * Selects the data from the store.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESFISelectors
   */
  static fetchAcesFiChapApplied = state =>
    state[selectors.moduleIdentifier].fetchAcesFiChapApplied.payload;

  /**
   * Selects the flag that is set while the get data request is in progress.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESFISelectors
   */
  static isFetchingFetchAcesFiChapApplied = state =>
    state[selectors.moduleIdentifier].isFetchingFetchAcesFiChapApplied.payload;

  /**
   * Selects the data errors for the server request.
   *
   * @param {Object} state
   * @function
   * @static
   * @memberof ACESFISelectors
   */
  static fetchAcesFiChapAppliedError = state =>
    state[selectors.moduleIdentifier].fetchAcesFiChapAppliedError.payload;
}
